import { create } from 'zustand'

/**
 * Full-screen red warning fired when a scan is rejected (cross-order skid,
 * type mismatch, blocked bundle, etc.). Phil asked for a hard-to-miss visual
 * cue so packaging operators don't keep scanning into a dead state. The
 * existing `toast.error` stays for the message log; the overlay is additive.
 *
 * The warning persists until the operator scans again (a new `flash` replaces
 * it) or touches the screen (`clear`) — operators kept missing the old
 * auto-dismiss and misplaced bundles as a result.
 */

interface ScanWarning {
  message: string
  /** Optional shorter label rendered prominently above the message. */
  title?: string
}

interface ScanWarningState {
  warning: ScanWarning | null
  flash: (message: string, opts?: { title?: string }) => void
  clear: () => void
}

export const useScanWarningStore = create<ScanWarningState>((set) => ({
  warning: null,
  flash: (message, opts) => {
    set({ warning: { message, title: opts?.title } })
  },
  clear: () => {
    set({ warning: null })
  }
}))
